import React from "react";
import FormFillContent from "../forms/FormFillContent";

// Admin's own page-level entry point for Form Fill — mounted ONLY by the
// /admin route tree. Renders the SAME shared runtime/values/validation/
// Save-Draft/Submit/DynamicFormRenderer/progress/file-handling content
// component that RoleFormFillPage.jsx renders for every other role.
// Admin teal theme applies ambiently via AdminLayout's `.admin-teal-theme`
// wrapper -- nothing form-related is duplicated here.
export default function AdminFormFillPage() {
  return (
    <div className="admin-form-page">
      <FormFillContent />
    </div>
  );
}
